import { Reveal } from "./Reveal";
import { site } from "../content/site";

export const About = () => (
  <section id="about" data-testid="about-section" className="py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-12 gap-10 lg:gap-16">
      <div className="col-span-12 lg:col-span-6" data-testid="about-story-content">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-teal-700 bg-teal-50 border border-teal-200/60 px-3 py-1.5 rounded-full inline-block">
            {site.about.eyebrow}
          </p>
          <h2 className="mt-6 font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
            {site.about.heading}
          </h2>
        </Reveal>
        {site.about.story.map((para, i) => (
          <Reveal key={i} delay={0.08 * (i + 1)}>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">{para}</p>
          </Reveal>
        ))}
      </div>

      <div className="col-span-12 lg:col-span-6 grid sm:grid-cols-2 gap-5 content-start lg:pt-16">
        {site.about.pillars.map((pillar, i) => (
          <Reveal key={pillar.title} delay={0.07 * i} className="h-full">
            <div className="h-full bg-white border border-slate-200 rounded-2xl p-6 transition-all duration-300 hover:border-teal-500/40 hover:shadow-[0_12px_40px_-16px_rgba(13,148,136,0.25)] hover:-translate-y-1">
              <span aria-hidden="true" className="font-mono text-xs text-teal-600">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-3 font-display text-lg font-semibold tracking-tight text-slate-900">
                {pillar.title}
              </h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{pillar.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
